import { useGT } from 'gt-react';
import type { APInvoiceLineItemSplitProposalAllocation } from '@erp/rpc';

export function PartKindLabel({
  kind,
}: {
  kind: APInvoiceLineItemSplitProposalAllocation['kind'];
}) {
  const gt = useGT();
  switch (kind) {
    case 'LOAD':
      return gt('Load freight', {
        context: 'part of a suggested split of an AP invoice line',
      });
    case 'PO':
      return gt('PO freight', {
        context: 'part of a suggested split of an AP invoice line',
      });
    case 'PICKUP':
      return gt('Pick-up', {
        context:
          'part of a suggested split of an AP invoice line: the extra pick-up billed on the PO',
      });
  }
}
